/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_v2_analytics_base_FilterItem } from './api_v2_analytics_base_FilterItem';
export type b2b_v1_analytics_CreateDefaultReport = {
    columns: Array<string>;
    filters?: Array<api_v2_analytics_base_FilterItem>;
    grouping: b2b_v1_analytics_CreateDefaultReport.grouping;
    name?: string;
    original_report_id?: string;
    recalculation_needed?: boolean;
    source: string;
};
export namespace b2b_v1_analytics_CreateDefaultReport {
    export enum grouping {
        USER = 'user',
        ACCOUNT = 'account',
        BANK = 'bank',
        INSTRUMENT = 'instrument',
    }
}

